// src/pages/NotFound.jsx
import styled from 'styled-components';

const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

const Wrapper = styled.div`
  text-align: center;
  padding: 4rem;
`;

const Code = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  color: red;
`;

const Message = styled.p`
  font-size: 1.2rem;
`;

export default function NotFound() {
  return (
    <PageWrapper>
      <Wrapper>
        <Code>404</Code>
        <Message>Page non trouvée</Message>
      </Wrapper>
    </PageWrapper>
  );
}
